import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';

import { useState } from 'react';
import { WrapperBox, MenuListItem, HeaderMobile } from './styled';
import { eventTracking } from '../../../../lib/gtm';

import MenuIcon from '@mui/icons-material/Menu';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import { ReactComponent as Prescriptions } from '../../../../images/prescription.svg';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { IconButton, ListItemIcon } from '@mui/material';
import { ReactComponent as LogiMobile } from '../../../../images/horizontal-mobile.svg';
import { ReactComponent as Exam } from '../../../../images/exam.svg';
import { Divider } from '../../Divider';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import Avatar from '../../Avatar';
import { useIsLoggedIn, useLogout } from '../../../../shared/hooks';

const MenuMobile = () => {
  const [open, setOpen] = useState(false);
  const {
    oyana: { me }
  } = useSelector((state: RootState) => state);
  const [logOut] = useLogout();
  const isLoggedIn = useIsLoggedIn();
  const handleToggleDrawer = () => {
    eventTracking.click({
      category: 'Menu Mobile',
      label: 'Close Menu'
    });
    setOpen(!open);
  };

  const lougOut = () => {
    logOut();
    handleToggleDrawer();
  };

  return (
    <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
      {isLoggedIn && (
        <IconButton onClick={() => handleToggleDrawer()} sx={{ color: 'neutrals.beige1' }}>
          <MenuIcon />
        </IconButton>
      )}

      <Drawer
        anchor="left"
        open={open}
        onClose={handleToggleDrawer}
        PaperProps={{ sx: { backgroundColor: 'neutrals.beige1', width: '80%' } }}
      >
        <WrapperBox role="presentation">
          <HeaderMobile>
            <LogiMobile />
            <CloseIcon onClick={handleToggleDrawer} />
          </HeaderMobile>
          <Divider sx={{ mx: 1, my: 0 }} />

          {me && (
            <Avatar name={me.nickName?.length > 0 ? me.nickName : me.firstName} profileImage={me.profileImageThumbnail} />
          )}
          <List>
            <ListItem disablePadding>
              <MenuListItem>
                <ListItemIcon>
                  <MedicalInformationOutlinedIcon />
                </ListItemIcon>
                <Link to="/">
                  <Typography variant="body2B">Página inicial</Typography>
                </Link>
              </MenuListItem>
            </ListItem>
            <ListItem disablePadding>
              <MenuListItem>
                <ListItemIcon>
                  <Prescriptions />
                </ListItemIcon>
                <Link to="/meus-arquivos">
                  <Typography variant="body2B">Meus arquivos</Typography>
                </Link>
              </MenuListItem>
            </ListItem>
            <ListItem disablePadding>
              <MenuListItem>
                <ListItemIcon>
                  <Exam />
                </ListItemIcon>
                <Link to="/meus-exames">
                  <Typography variant="body2B">Meus exames</Typography>
                </Link>
              </MenuListItem>
            </ListItem>
            <ListItem disablePadding>
              <MenuListItem onClick={() => lougOut()}>
                <ListItemIcon>
                  <LogoutOutlinedIcon />
                </ListItemIcon>
                <Typography variant="body2B">Sair da conta</Typography>
              </MenuListItem>
            </ListItem>
          </List>
        </WrapperBox>
      </Drawer>
    </Box>
  );
};

export default MenuMobile;
